var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-input-select',{attrs:{"fullwidth":_vm.fullwidth,"label":_vm.label,"loading":_vm.casinosMeta.loading,"options":_vm.casinoOptions,"value":_vm.value},on:{"input":_vm.handleCasinoSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }